import { io } from 'socket.io-client';

const URL = 'https://device-info-ai.dev.wingpay.co/';

console.log({URL})
export const socket = io(URL);